import { HttpClient } from '@angular/common/http';
import { Base } from '../base';
import { map } from 'rxjs/operators';

export class Oracles extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/oracles`);
  }

  getSpotPrice() {
    return this.api.get('spot_price');
  }

  getSignedData() {
    return this.api.get('signed_data');
  }
}
